import { BoxProps, Flex } from '@chakra-ui/react'
import ClipBox from './ClipBox'
import { getRarityColorMap, rarityType } from '../constants/skinPropertes'
import { colors } from '../theme/cssVariables'

const RushSkinCardWrapper = ({
  children,
  ...props
}: BoxProps & { isLoaded?: boolean; rarity?: rarityType }) => {
  const { isLoaded = true, rarity, borderColor, ...rest } = props
  return (
    <Flex
      position={'relative'}
      pb={'1px'}
      width={'230px'}
      height={rest?.height || '280px'}
      px={'1px'}
      overflow={'hidden'}
      cursor={'pointer'}
      className="skin-box-card"
    >
      <ClipBox
        width={'100%'}
        height={'100%'}
        borderColor={typeof borderColor === 'string' ? borderColor : colors.colorB5}
        background={'linear-gradient(180deg, #100F17 0%, #161522 89.23%)'}
        // borderTop={`1px solid ${isLoaded && rarity ? rarityColorMap[rarity].border : colors.colorB5}`}
        _before={{
          content: '""',
          position: 'absolute',
          top: '-50%',
          left: '10%',
          width: '80%',
          background: `${isLoaded && rarity ? `${getRarityColorMap(rarity as unknown as rarityType).border}4D` : ''}`,
          height: '80%',
          zIndex: '-1',
          filter: 'blur(65px)',
          borderRadius: '50%',
        }}
        flexDirection={'column'}
        alignItems={'center'}
        gap={[2, 4]}
        justifyContent={'flex-start'}
        position={'relative'}
        {...rest}
      >
        {children}
      </ClipBox>
    </Flex>
  )
}

export default RushSkinCardWrapper
